import type { SdgItem } from "@/types/domain";

/** 提案对齐的可持续发展目标 */
export const SDGS: SdgItem[] = [
  { id: "education", number: 4 },
  { id: "water", number: 6 },
  { id: "innovation", number: 9 },
  { id: "cities", number: 11 },
  { id: "consumption", number: 12 },
  { id: "climate", number: 13 },
  { id: "lifeBelowWater", number: 14 },
  { id: "partnerships", number: 17 },
];
